import { Textarea, TextAreaProps } from '@heroui/react'
import { Field, FieldProps } from 'formik'
import { motion } from 'framer-motion'

export interface TextareaFormikProps extends Omit<TextAreaProps, 'classNames'> {
  label?: string
  name: string
  classNameContainer?: string
  classNames?: {
    label?: string[]
    input?: string[]
    innerWrapper?: string
    inputWrapper?: string[]
  }
}

const TextareaFormik = ({
  label,
  classNameContainer,
  classNames,
  name,
  ...props
}: TextareaFormikProps) => {
  return (
    <Field name={name} {...props}>
      {({ field, meta }: FieldProps) => (
        <motion.div className={classNameContainer}>
          <Textarea
            labelPlacement="outside"
            {...field}
            className=" h-full"
            errorMessage={meta.error || meta.touched ? meta.error : ''}
            label={label}
            placeholder={props.placeholder}
            radius="sm"
            variant={'bordered'}
            classNames={{
              label: [
                'text-gray-900',
                'dark:text-foreground',
                'group-data-[filled-within=true]:text-gray-900',
                'dark:group-data-[filled-within=true]:text-white',
                'group-data-[invalid=true]:text-danger',
                'dark:group-data-[invalid=true]:text-danger',
              ],
              input: [
                'bg-transparent',
                'text-gray-900',
                'dark:text-white',
                'placeholder:text-gray-500',
                'dark:placeholder:text-white/60',
                'group-data-[invalid=true]:placeholder:text-danger',
              ],
              innerWrapper: 'bg-transparent',
              inputWrapper: [
                'bg-gray-50',
                'dark:bg-[#1e1e20]',
                'border-gray-200',
                'dark:border-default-600',
                'hover:bg-gray-100',
                'dark:hover:bg-[#1e1e20]/70',
                'group-data-[focus=true]:bg-gray-100',
                'dark:group-data-[focus=true]:bg-[#1e1e20]/50',
                'group-data-[focus=true]:border-primary',
                'dark:group-data-[focus=true]:border-primary',
                '!cursor-text',
              ],
              ...classNames,
            }}
            {...props}
            type={'text'}
          />
        </motion.div>
      )}
    </Field>
  )
}

export default TextareaFormik
